import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { Hosts } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: Hosts = {
  broadcast: '',
  ecs: '',
  graphql: '',
  legacy: '',
  msGraph: '',
  ocv: '',
  substrate: '',
  suiteHeader: '',
  telemetry: '',
  tenor: '',
  thumbnails: '',
  web: '',
  designerApp: '',
};

const reducer: Reducer<Hosts, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.hosts;
    default:
      return state;
  }
};

export default reducer;
